export const getNodesFromConnection = <T>(connection?: Connection<T>): T[] => {
  return connection?.edges.map(({ node }) => node) ?? [];
};
